/** Available dashboard queue types. */
export var DashboardQueuesType;
(function (DashboardQueuesType) {
    DashboardQueuesType["All"] = "all";
    DashboardQueuesType["Agent"] = "agent";
    DashboardQueuesType["Favourite"] = "favourite";
    DashboardQueuesType["Archived"] = "archived";
})(DashboardQueuesType || (DashboardQueuesType = {}));
